module.exports = __webpack_public_path__ + "static/media/Mockup2.ea4fc901.png";